export default function (context, val) {
  let settings = context.rootState.user.setting.items;
  context.dispatch('set_title', 'Добавление требования', {root: true});
  let category = context.rootGetters['dictionary/paymentType/getById'](settings.DefaultRegularAgreementPaymentType).CategoryId;
  let cash = settings.DefaultRegularAgreementPaymentSource;
  let account = settings.DefaultRegularAgreementPaymentSource;
  switch (category) {
    case 0:
      if (!context.rootState.dictionary.cash.list.filter(i => i.value === cash)[0]) {
        if (context.rootState.dictionary.cash.list[0]) cash = context.rootState.dictionary.cash.list[0].value;
      }
      break;
    case 1:
      if (!context.rootState.dictionary.paymentAccount.list.filter(i => i.value === account)[0]) {
        if (context.rootState.dictionary.paymentAccount.list[0]) account = context.rootState.dictionary.paymentAccount.list[0].value;
      }
      break;
  }
  context.commit('set_form', {
    Id: 0,
    CertificateId: '',
    CertificateName: '',
    Name: '',
    NameLat: '',
    PaymentDirection: 1,
    PaymentOperationID: settings.DefaultRegularAgreementPaymentOperation,
    RateArticleId: null,
    CategoryId: category,
    PaymentTypeId: settings.DefaultRegularAgreementPaymentType,
    CashId: cash,
    PaymentAccountId: account,
    AccountNumber: '',
    ContragentType: context.rootGetters['dictionary/contragentType/list'](settings.DefaultRegularAgreementPaymentOperation)[0].value,
    ContragentID: null,
    ContragentName: '',
    PartnerLegalEntityId: null,
    Sum: 0,
    CurrencyId: 1,
    PaymentDate: '',
    DocumentNumber: context.state.system.OutcomePaymentNumber,
    Comment: '',
    RegularPaymentTypeId: 4,
    dayMonth: 1,
    dayWeek: 1,
    dayYear: '',
    dayOne: val.date,
    NotificationsEndDate: '',
    AgreementCodes: [],
  });
  context.dispatch('change_Name', 'Оплата заявки #' + val.id);
  context.dispatch('agreements/add', {
    id: val.id,
    callback: agreement => {
      agreement.requests.forEach(i => {
        i.sum = i.out;
      });
      context.commit('set_form', {
        CurrencyId: agreement.AGCurrency,
      });
      context.dispatch('agreement_getCourse', agreement.code);
      if (context.getters.computed_hiddenClient || context.getters.computed_hiddenOperator) context.dispatch('change_ContragentType', 7);
      setTimeout(() => {
        context.commit('set_form', {
          Sum: context.getters['agreements/sum_all'],
        });
        context.commit('set_load', {
          data: false,
        });
      });
      // agreement.ag.course = i.Course ? i.Course : 1;
      // if (form.ContragentType === 3) {
      //     if (i.OrderPrices) i.OrderPrices.forEach(j => {
      //         agreement.requests.forEach(l => {
      //             if (j.RequestId === l.value) {
      //                 l.sum = Math.round(j.Spread / agreement.ag.course * 100) / 100;
      //             }
      //         });
      //     });
      // } else {
      //     if (agreement.requests[0]) agreement.requests[0].sum = Math.round(i.Spread / agreement.ag.course * 100) / 100;
      // }
      // agreement.ag.comment = i.Comment;
      // if (i.Date) agreement.ag.date = i.Date.Serialized;
    }
  })
}
